var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scout-tab-panel", {
    attrs: {
      "is-active": _vm.isActive,
      title: _vm.title,
      name: "reservation",
      link: _vm.link,
      tooltip: _vm.tooltip,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }